"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = getCalendarMonthWidth;

function getCalendarMonthWidth(daySize) {
  var calendarMonthPadding = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
  return 7 * daySize + 2 * calendarMonthPadding + 1;
}


/*****************
 ** WEBPACK FOOTER
 ** ./~/react-dates/lib/utils/getCalendarMonthWidth.js
 ** module id = 670
 ** module chunks = 0
 **/